<template>
    <SoliForm
        :title="
            mode.Teacher
                ? 'Add New Teacher'
                : mode.Student
                ? `Create New ${adult ? 'Student' : 'Family'}`
                : 'Add Staff Member'
        "
        text="Save"
        icon="save"
        ref="form"
        :limit-scroll="$vuetify.breakpoint.sm"
        :mobile-scroll="$vuetify.breakpoint.xs"
        :errors="errors"
        @reset="$emit('reset')"
        @submit="submit"
        persistent
    >
        <template #body>
            <div class="flex flex-col gap-4">
                <v-switch
                    v-if="mode.Student"
                    v-model="adult"
                    label="This is an adult student"
                    class="mb-1 mt-0"
                    dense
                    hide-details="auto"
                ></v-switch>
                <div v-if="!adult && mode.Student" class="soli-grey">
                    Parent Information:
                </div>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="form.first_name"
                            prepend-inner-icon="person"
                            label="First Name"
                            outlined
                            :rules="rules.input"
                            dense
                            hide-details="auto"
                        ></v-text-field
                    ></v-col>
                    <v-col>
                        <v-text-field
                            v-model="form.last_name"
                            @input="
                                form.children.forEach(
                                    (e) => (e.last_name = $event)
                                )
                            "
                            label="Last Name"
                            outlined
                            :rules="rules.input"
                            dense
                            hide-details="auto"
                        ></v-text-field
                    ></v-col>
                </v-row>
                <SoliText
                    v-model="form.email"
                    :errors="errors.email"
                    :rules="rules.email"
                    icon="alternate_email"
                    label="Email"
                    hide-details="auto"
                    validateOnBlur
                ></SoliText>
                <SoliPhone
                    v-model="form.phone"
                    icon="phone"
                    label="Phone"
                    :errors="errors.phone"
                    hide-details="auto"
                />

                <div v-if="!adult && mode.Student" class="mt-3">
                    <v-divider />

                    <div class="soli-grey my-5">Child Information:</div>
                    <div class="py-3 flex flex-col gap-4">
                        <v-row
                            v-for="(child, idx) of form.children.length"
                            :key="child[idx]"
                        >
                            <v-col class="py-0">
                                <v-text-field
                                    v-model="form.children[idx].first_name"
                                    prepend-inner-icon="person"
                                    label="First Name"
                                    outlined
                                    :rules="rules.input"
                                    dense
                                    hide-details="auto"
                                ></v-text-field
                            ></v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    v-model="form.children[idx].last_name"
                                    label="Last Name"
                                    outlined
                                    :rules="rules.input"
                                    dense
                                    hide-details="auto"
                                ></v-text-field
                            ></v-col>
                        </v-row>
                    </div>
                    <div class="mt-3 pl-1">
                        <v-btn
                            v-show="form.children.length <= 3"
                            x-small
                            outlined
                            class="soli-round soli-blue-text my-3"
                            @click="
                                form.children.push({
                                    first_name: null,
                                    last_name: form.last_name,
                                })
                            "
                            >Add Another Child</v-btn
                        >
                        <v-btn
                            v-show="form.children.length > 1"
                            x-small
                            outlined
                            class="soli-round soli-red-text my-3 ml-3"
                            @click="form.children.splice(-1)"
                            >Remove Child</v-btn
                        >
                    </div>
                </div>
            </div>
        </template>
    </SoliForm>
</template>

<script>
import SoliForm from "./../Base/SoliForm";
import TeacherCertification from "./../Teachers/TeacherCertification";
import StaffPayRate from "./../Staff/StaffPayRate";
import StaffRoles from "./../../Components/Staff/StaffRoles";

export default {
    components: {
        TeacherCertification,
        StaffPayRate,
        StaffRoles,
    },
    props: {
        errors: {},
        mode: {
            type: Object,
            default() {
                return {
                    Teacher: false,
                    Student: true,
                    Staff: false,
                };
            },
        },
    },
    data() {
        return {
            form: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                role_name: null,
                children: [
                    {
                        first_name: null,
                        last_name: null,
                    },
                ],
            },
            rules: SoliForm.formRules,
            adult: false,
        };
    },
    methods: {
        submit() {
            if (!this.$refs.form.$refs.form.validate()) return;
            this.$refs.form.loading = true;

            if (this.adult || this.mode.Teacher || this.mode.Staff) {
                this.form.children = null;
            }

            this.form.role_name = Object.keys(this.mode).find(
                (e) => this.mode[e]
            );

            this.$inertia.post(route("users.store"), this.form, {
                preserveState: (page) => Object.keys(page.props.errors).length,
                preserveScroll: true,
                onSuccess: () => {
                    this.$emit("success");
                    //this.$refs.form.loading = false;
                },
                onError: () => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                    this.$refs.form.loading = false;
                },
            });
        },
    },
};
</script>
